<template>
  <div class="test-start-page">
    <div class="header">
      <img :src="require('@/pages/2019/LiuXuanTest/assets/img/start/logo.png')" alt="">
    </div>
    <div class="action">
      <div class="btn"
           @click="handleClick('no')"
      >
        不是，我还没孩子
      </div>
      <div class="btn"
           @click="handleClick('yes')"
      >
        是的，我有孩子了
      </div>
    </div>
    <img class="circle"
         :src="require('@/pages/2019/LiuXuanTest/assets/img/start/circle.png')"
         alt=""
    >
    <test-popup :type="type"
                :show.sync="showPopup"
                @userName="handleSendUserName"
    />
  </div>
</template>

<script>
  import TestPopup from '@/pages/2019/LiuXuanTest/components/TestPopup';

  export default {
    name: 'LiuXuanTestStartPage2019',
    components: {
      TestPopup,
    },
    data() {
      return {
        type: '',
        showPopup: false,
      };
    },
    methods: {
      handleClick(type) {
        this.type = type === 'yes' ? 'yes' : 'no';
        this.showPopup = true;
      },
      handleSendUserName(data) {
        this.$emit('userName', data);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .test-start-page {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: @color-white;
    .circle {
      position: absolute;
      z-index: @z-index-medium;
      right: 0;
      bottom: 0;
      width: 230px;
      height: 178px;
      display: block;
    }
  }
  .action {
    width: 550px;
    position: absolute;
    z-index: @z-index-large;
    left: calc(50% - 275px);
    right: 0;
    bottom: 120px;
    .btn {
      width: 550px;
      height: 116px;
      padding-bottom: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: @color-white;
      font-size: 30px;
      line-height: 1;
      background: url('~@/pages/2019/LiuXuanTest/assets/img/start/btn.png') no-repeat;
      background-size: contain;
      &:not(:last-child) {
        margin-bottom: @size-extra-small / 2;
      }
    }
  }

  .header {
    position: relative;
    width: 100%;
    height: 916px;
    background: url('~@/pages/2019/LiuXuanTest/assets/img/start/bg.png') no-repeat;
    background-size: contain;
    img {
      position: absolute;
      left: @size-medium;
      top: 44px;
      width: 196px;
      height: 64px;
      display: block;
    }
  }

</style>
